<div class="card">
    <img class="card-img-top" src=" ./assets/image/logo.jpg" alt="Card logo" />
    <div class="card-title">Admin Register</div>

    <div class="card-body">
        <form [formGroup]="userForm">
            <div class="form-group row">
                <div class="col-md-6">
                    <label for="firstName">First Name</label>
                    <input type="text" formControlName="firstName" class="form-control" id="firstName"
                        placeholder="Enter your first name" [ngClass]="{'is-invalid':isSubmitted && userForm.get('firstName')?.invalid
                                            }" maxlength="30" />
                    <div *ngIf="userForm.get('firstName')?.invalid && isSubmitted" class="invalid-feedback">
                        <div *ngIf="userForm.get('firstName')?.errors?.['pattern']">Please enter a valid name.</div>
                        <div *ngIf="userForm.get('firstName')?.errors?.['maxlength']">Max 30 characters allowed</div>
                        <div *ngIf="userForm.get('firstName')?.errors?.['required']">First Name is required</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="lastName">Last Name</label>
                    <input type="text" formControlName="lastName" class="form-control" id="lastName"
                        placeholder="Enter your last name" maxlength="30" />
                </div>
            </div>
            <div class="form-group">
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="text" formControlName="email" class="form-control" placeholder="Enter your email"id="email"
                        [ngClass]="{'is-invalid': isSubmitted && userForm.get('email')?.invalid
                                                        }" maxlength="30" />
                    <div *ngIf="isSubmitted && userForm.get('email')?.invalid" class="invalid-feedback">
                        <div *ngIf="userForm.get('email')?.errors?.['pattern']">Invalid email format</div>
                        <div *ngIf="userForm.get('email')?.errors?.['required']">Email is required</div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input type="password" formControlName="password" class="form-control" placeholder="Enter your password" id="password"
                    [ngClass]="{'is-invalid': isSubmitted && userForm.get('password')?.invalid}" />

                <div *ngIf="isSubmitted && userForm.get('password')?.invalid" class="invalid-feedback">
                    <div *ngIf="userForm.get('password')?.errors?.['pattern']">Please enter a valid password.</div>
                    <div *ngIf="userForm.get('password')?.errors?.['minlength']">Minimum 6 characters required</div>
                    <div *ngIf="userForm.get('password')?.errors?.['required']">Password is required</div>
                </div>
            </div>

            <div class="form-group">
                <label for="confirmPassword">Confirm Password</label>
                <input type="password" formControlName="confirmPassword" placeholder="Enter your confirm password" id="confirmPassword"
                    class="form-control" [ngClass]="{
                                                                                                               'is-invalid': isSubmitted && userForm.get('confirmPassword')?.invalid
                                                                                                             }" />

                <!-- Field-level error -->
                <div *ngIf="isSubmitted && userForm.get('confirmPassword')?.errors" class="invalid-feedback">
                    <div *ngIf="userForm.get('confirmPassword')?.errors?.['required']">
                        Confirm password is required
                    </div>
                    <div *ngIf="userForm.get('confirmPassword')?.errors?.['minlength']">
                        Minimum 6 characters required
                    </div>
                </div>

                <!-- Group-level error -->
                <div *ngIf="isSubmitted && userForm.get('confirmPassword')?.errors?.['matching']"
                    class="invalid-feedback">
                    Passwords do not match
                </div>

            </div>
            <div class="form-group float-end">
                <button class="btn btn-secondary submit" type="button" (click)="redirectLogin()">
                    Cancel
                </button>
                <button class="btn btn-primary submit" style="margin-left: 10px;" type="submit"
                    (click)="submitUser()">
                    Submit
                </button>
            </div>
        </form>
    </div>
</div>